import React from 'react';
import { IonBackButton, IonButton, IonButtons, IonContent, IonHeader, IonItem, IonLabel, IonList, IonTitle, IonToggle, IonToolbar } from '@ionic/react';
import { useTranslation } from 'react-i18next';

const NotificationsSettings = () => {
  const [friendsNotifications, setFriendsNotifications] = React.useState(true);
  const [gameInvitations, setGameInvitations] = React.useState(true);
  const [newMessages, setNewMessages] = React.useState(true);
  const [appUpdates, setAppUpdates] = React.useState(true);
  const { t } = useTranslation();
  return (
    <>
      <IonHeader>
        <IonToolbar className="md:hidden">
          <IonButtons slot="start">
            <IonBackButton text={t('back')} defaultHref="/settings" />
          </IonButtons>
          <IonTitle>{t('notifications')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>

        <IonList lines='none'>
          <h1 className="text-3xl font-bold pt-6 hidden md:block">{t('notifications')}</h1>
          <span className="ml-4 text-muted-foreground text-sm uppercase">{t('friends')}</span>
          <IonItem>
            <IonToggle checked={friendsNotifications} onIonChange={(e) => setFriendsNotifications(e.detail.checked)}>
              {t('notifications_friends_requests')}
            </IonToggle>
          </IonItem>
          <IonItem>
            <IonToggle checked={gameInvitations} onIonChange={(e) => setGameInvitations(e.detail.checked)} justify="space-between">
              {t('notifications_game_invitations')}
            </IonToggle>
          </IonItem>
          <IonItem>
            <IonToggle checked={newMessages} onIonChange={(e) => setNewMessages(e.detail.checked)} justify="space-between">
              <IonLabel>{t('notifications_new_messages')}</IonLabel>
            </IonToggle>
          </IonItem>
          <IonItem>
            <IonToggle checked={appUpdates} onIonChange={(e) => setAppUpdates(e.detail.checked)} justify="space-between">
              <IonLabel>{t('notifications_friends_new_posts')}</IonLabel>
            </IonToggle>
          </IonItem>
          <IonItem>
            <IonToggle checked={appUpdates} onIonChange={(e) => setAppUpdates(e.detail.checked)} justify="space-between">
              <IonLabel>{t('responses_under_posts')}</IonLabel>
            </IonToggle>
          </IonItem>
          <span className="ml-4 text-muted-foreground text-sm uppercase">{t('club')}</span>
          <IonItem>
            <IonToggle checked={appUpdates} onIonChange={(e) => setAppUpdates(e.detail.checked)} justify="space-between">
              <IonLabel>{t('announcements')}</IonLabel>
            </IonToggle>
          </IonItem>
          <IonItem>
            <IonToggle checked={appUpdates} onIonChange={(e) => setAppUpdates(e.detail.checked)} justify="space-between">
              <IonLabel>{t('golf_post_new_events')}</IonLabel>
            </IonToggle>
          </IonItem>
        </IonList>
      </IonContent>
    </>
  );
};

export default NotificationsSettings;
